module.exports = __webpack_public_path__ + "img/1536328273.bba92ddb.jpg";